import { IItemCache } from '../IItemCacheObserver';
import { IFacetMapping } from '../Facet';
import { configurationItemKey } from '../../facets/ConfigurationFacets';

/**
 * The the current state of configuration facets from the item cache.
 * Use this function to bind component state to configuration values.
 *
 * @public
 */
export function getConfiguration<TFacets extends object>(itemCache: IItemCache, mapping: IFacetMapping<TFacets>): Partial<TFacets> {
  return itemCache.demandItem(mapping, configurationItemKey);
}
